import { combineReducers } from 'redux-immutable';
import { reducer as loginReducer } from '../pages/Login/Login.reducer';
import { reducer as myProfileReducer } from '../pages/MyProfile/MyProfile.reducer';
import { reducer as settingsReducer } from '../pages/Settings/Settings.reducer';

export default combineReducers({
    login: loginReducer,
    myProfile: myProfileReducer,
    settings: settingsReducer,
});